import { jsxs as o, jsx as l } from "react/jsx-runtime";
const Z = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m43.967 11.272 8.761 32.695-32.695 8.761-8.761-32.695 32.695-8.761Zm2.829-4.899L6.373 17.204l10.831 40.423 40.423-10.831L46.796 6.373Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m24.281 16.422-6.576 1.762 1.762 6.577 6.576-1.762-1.762-6.577ZM37.441 12.896l-6.576 1.762 1.762 6.577 6.576-1.762-1.762-6.577Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m19.474 24.749-6.576 1.762 1.762 6.576 6.576-1.762-1.762-6.576Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m27.8 29.556-6.576 1.762 1.762 6.576 6.576-1.762-1.762-6.576ZM32.635 21.223l-6.577 1.762 1.762 6.576 6.577-1.762-1.762-6.576Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m40.96 26.03-6.576 1.762 1.762 6.576 6.576-1.762-1.762-6.576ZM45.794 17.697l-6.576 1.762 1.762 6.576 6.577-1.762-1.763-6.576ZM22.999 37.904l-6.576 1.762 1.762 6.576 6.576-1.762-1.762-6.576Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m31.325 42.71-6.577 1.763 1.762 6.576 6.577-1.762-1.762-6.576ZM36.159 34.378l-6.576 1.762 1.762 6.576 6.576-1.762-1.762-6.576Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m44.485 39.185-6.577 1.762 1.762 6.576 6.577-1.762-1.762-6.576ZM49.319 30.852l-6.576 1.762 1.762 6.576 6.576-1.762-1.762-6.576Z"
        }
      )
    ]
  }
);
export {
  Z as Placeholder
};
